import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import axios from "axios";
import {t} from "../../../../lang/index"

const BookingsStatistics: React.FC = () => {
    const [stats, setStats] = useState<{ label: string; value: number }[]>([]);
    const [loading, setLoading] = useState(true);

    const fetchStats = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/empresas/dashboard/bookings-stats`,
                {
                    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
                }
            );
            setStats(res.data);
        } catch (error) {
            console.error("Erro ao carregar estatísticas de reservas:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);


    const options: ApexOptions = {
        chart: { type: "donut" },
        labels: stats.map((s) => s.label),
        legend: { position: "bottom" },
        dataLabels: { enabled: true },
        colors: [
            "#0d6efd", // Azul primário
            "#20c997", // Verde-água
            "#ffc107", // Amarelo
            "#a855f7", // Roxo
            "#fd7e14", // Laranja
            "#6c757d", // Cinza
        ],
    };

    const series = stats.map((s) => s.value);

    return (
        <div className="col-xl-4 d-flex">
            <div className="card shadow-none flex-fill">
                <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h6>{t("BookingsStatistics.titulo")}</h6>
                    </div>

                    {loading ? (
                        <p className="text-center text-muted">{t("BookingsStatistics.loading")}</p>
                    ) : (
                        <>
                            <div className="text-center mb-3">
                                <ReactApexChart
                                    options={options}
                                    series={series}
                                    type="donut"
                                    height={181}
                                />
                            </div>

                            {stats.map((s, i) => (
                                <div
                                    key={i}
                                    className="d-flex align-items-center justify-content-between mb-2"
                                >
                                    <h6 className="border-icon teal">{s.label}</h6>
                                    <p className="fs-14">
                                        <span className="text-gray-9 fw-medium">{s.value}</span> Bookings
                                    </p>
                                </div>
                            ))}

                            {stats.length === 0 && (
                                <p className="text-center text-muted mb-0">
                                    {t("BookingsStatistics.none")}
                                </p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default BookingsStatistics;